import type { StationFilters } from '@reliance/types/filters/StationFilters';
import type { Station } from '@reliance/types/models/Station/Station';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export const useStations = (filters?: StationFilters) =>
  useAsync<Station[]>(
    () => api.get<Station[]>('/station', { params: filters }).then((r) => r.data),
    [JSON.stringify(filters ?? {})]
  );

export const useStationById = (stationId: string | number | null | undefined) =>
  useAsync<Station | null>(
    async () => {
      if (stationId == null || stationId === '') {
        return null;
      }
      const response = await api.get<Station>('/station/by-id', { params: { id: stationId } });
      return response.data;
    },
    [stationId == null || stationId === '' ? '' : String(stationId)]
  );
